// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import Waypoint from 'react-waypoint'

// Internal Dependencies:
import LoadScript from 'church-theme-library/containers/LoadScript'
import getDeltaFromZoomLevel from './getDeltaFromZoomLevel'

class Map extends React.Component {
	constructor( props ) {
		super( props )

		this.mapRef = React.createRef()

		let loadInteractiveMap = false

		if ( props.loadInteractiveMap ) {
			loadInteractiveMap = true
		}

		this.state = {
			inViewport: false,
			loadInteractiveMap: loadInteractiveMap
		}
	}

	componentWillReceiveProps( nextProps ) {
		const { lat, lng } = this.props

		if ( lat != nextProps.lat || lng != nextProps.lng ) {
			this.setState( {
				inViewport: false,
				loadInteractiveMap: true
			} )
		}
	}

	onEnter = () => {
		if ( this.state.inViewport ) {
			return
		}

		this.setState( {
			inViewport: true
		} )

		const shouldAutoDownload = this.shouldAutoDownload()

		if ( shouldAutoDownload ) {
			this.setState( {
				loadInteractiveMap: true
			} )
		} else {
			this.setState( {
				loadInteractiveMap: true
			} )
		}
	}

	shouldAutoDownload = () => {
		const { connection } = this.props

		if ( connection.possiblySlowNetwork ) {
			return false
		}

		if ( ! connection.effectiveType ) {
			return true
		}

		const { downlink, rtt, effectiveType } = connection

		switch ( effectiveType ) {
			case 'slow-2g':
			case '2g':
				return false

			case '3g':
			case '4g':
			default:
				return true
		}
	}

	handleScriptLoad = () => {
		const loadingInterval = setInterval( () => {
			if ( 'undefined' != typeof mapkit ) {
				clearInterval( loadingInterval )

				this.init()
			}
		}, 500 )
	}

	init = () => {
		const { lat, lng, title, subtitle } = this.props

		mapkit.init( {
			authorizationCallback: done => {
				done( siteData.apple_maps_api_token )
			}
		} )

		if ( this.mapRef.current ) {
			const coordinates = new mapkit.Coordinate( lat, lng )

			// Setup map:
			this.map = new mapkit.Map( this.mapRef.current, {
				showsMapTypeControl: false,
				showsCompass: mapkit.FeatureVisibility.Hidden
			} )

			// Create the CoordinateRegion from the delta latitude and
			// the delta longitude multiplied by 111 (1deg = 111km).
			const delta = getDeltaFromZoomLevel( this.map, coordinates, 11 )
			const span = new mapkit.CoordinateSpan( delta.latitudeDelta * 111, delta.longitudeDelta * 111 )
			const region = new mapkit.CoordinateRegion( coordinates, span )

			this.map.setRegionAnimated( region )

			// Add marker:
			const markerOptions = {
				url: { 1: `${siteData.images_url}maps/map-pin.svg` }
			}

			if ( title ) {
				markerOptions.title = title
			}

			if ( subtitle ) {
				markerOptions.subtitle = subtitle
			}

			const annotation = new mapkit.ImageAnnotation( coordinates, markerOptions )

			this.map.addAnnotation( annotation )
		}
	}

	render() {
		const { staticImage } = this.props
		const { loadInteractiveMap } = this.state

		return (
			<div className="map-inner">
				<Waypoint onEnter={ this.onEnter } />

				{ loadInteractiveMap &&
					<LoadScript
						src="https://cdn.apple-mapkit.com/mk/5.0.x/mapkit.js"
						callback={ this.handleScriptLoad }
					/>
				}

				<div className="map-canvas">
					{ ( staticImage && staticImage.thumb ) &&
						<img src={ staticImage.thumb } alt="" />
					}

					<div className="map-canvas-inner" ref={ this.mapRef }></div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		connection: state.site.connection
	}
}

export default connect( mapStateToProps )( Map )
